import { useTranslation } from 'react-i18next'
import { Button } from '@structural-climbing/ui'

/**
 * "Log TOP", floating above the tab bar while you are in the gym.
 *
 * Logging is the one thing Home is opened for between climbs, so it stays one
 * thumb away however far down the page you are, instead of living inside a
 * card that scrolls away. On a phone it clears the tab bar and the home
 * indicator; from md up there is no tab bar, only the sidebar.
 *
 * Its own layer, above the tab bar and the fade over it (which painted across
 * the button when the two shared `--z-nav`), below sheets and modals.
 */
export function LogTopFab({ onPress }: { onPress: () => void }) {
  const { t } = useTranslation()
  return (
    <Button
      onPress={onPress}
      radius="full"
      size="lg"
      data-testid="log-top-fab"
      className="fixed bottom-[calc(3.5rem+var(--safe-b)+1rem)] right-4 z-[var(--z-fab)] bg-[var(--gym-primary)] px-5 font-bold text-[var(--gym-on-primary)] shadow-[0_10px_28px_-6px_rgb(16_12_8/0.35),0_2px_6px_rgb(16_12_8/0.15)] ring-4 ring-[var(--gym-page)] md:bottom-6 md:right-6"
      startContent={
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2.4}
          strokeLinecap="round"
          className="h-5 w-5"
          aria-hidden
        >
          <path d="M12 5v14M5 12h14" />
        </svg>
      }
    >
      {t('session.logTop')}
    </Button>
  )
}
